import { defineStyleConfig } from '@chakra-ui/styled-system'

export const headingTheme = defineStyleConfig({
  defaultProps: {
    size: 'lg',
  },
})
